import { render, staticRenderFns } from "./Novo-Cliente.vue?vue&type=template&id=6d8c40ad&scoped=true&"
import script from "./Novo-Cliente.vue?vue&type=script&lang=js&"
export * from "./Novo-Cliente.vue?vue&type=script&lang=js&"
import style0 from "./Novo-Cliente.vue?vue&type=style&index=0&id=6d8c40ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8c40ad",
  null
  
)

export default component.exports